import fly from './fly'
import { getAuth } from '@/util/storage'
const auth =  getAuth() // 'EKRFP70gGVW2bCjlsaFT9rVLMGgAQ9Sjjpd8cvB-m16W0YjnKLdOvFo1qSq2y-Uw'

export const fetchEarnPoints = () =>
  fly.get(`/mall/v2/integral/earnIntegralDetail.json`, { auth })